export const defaultMapCenter = { latitude: 35.689599, longitude: 139.692304 };

export const defaultMapZoom = 14;

// 1.5 km is the default radius
export const defaultMapSearchRange = 1500;
